<template lang="pug">
component.editable(
  :class="{ 'editable--prose prose': keepOneParagraph, 'edit-mode-warning': !validEditPath && DEV }"
  :editPath="editPath || null"
  :is="EditorComponent"
  :keepOneParagraph="keepOneParagraph"
  :k="k"
  :text="text"
  :type="type"
  :values="values"
  :key="locale"
  :locale="locale"
  :translating="translating"
)
</template>

<script setup lang="ts">
import UcText from '../components/uc-text.vue';
// import UcTiptap from '../lib/uc-tiptap.vue';
import { computed } from 'vue';
import useEditMode from '../stores/useEditMode';
import { storeToRefs } from 'pinia';
import maybeGetTiptap from '../lib/MaybeTiptap';
import useContent from '../stores/useContent';

const { compiled } = useContent();

const { available } = storeToRefs(useEditMode());

// FIXME lazy load tiptap without breaking title animation (change of #course-title element)
// const EditorComponent = available.value
//   ? defineAsyncComponent({
//       loader: async () => import('../lib/uc-tiptap.vue'),
//       loadingComponent: UcText,
//       errorComponent: UcText,

//       // prevents flash when swapping for UcText
//       delay: 0
//     })
//   : UcText;

const locale = computed(() => window.app.suspend.locale);

const props = defineProps({
  text: { default: '', type: String },
  type: { default: 'div', type: String },
  editPath: { default: '', type: String },
  /** Translation key — forwarded to `uc-text` / TipTap. */
  k: { type: String, default: null },
  /**
   * `${path}` replacements for `uc-text` `fillTemplates` (e.g. assessment intro).
   * Must be forwarded explicitly; fallthrough does not reliably reach `<component>`.
   */
  values: {
    type: Object,
    default: () => ({})
  }
});

const DEV = import.meta.env.DEV;

const validEditPath = computed(
  () =>
    props.editPath &&
    !props.editPath.startsWith('undefined.') &&
    !props.editPath.startsWith('quizzes')
);

const translating = computed(
  () => locale.value !== (compiled['default-language'] || 'en-GB')
);

// does the text contain any ${var} templates?
const containsVarTemplates = computed(() => {
  return (props.text.match(/\$\{[^}]+\}/g) || []).length > 0;
});

const EditorComponent = computed(() =>
  available.value && validEditPath.value && !containsVarTemplates.value
    ? maybeGetTiptap()
    : UcText
);

const keepOneParagraph = computed(() => props.type === 'div');
</script>

<!-- DEV build only warning when editPath is missing. Disabled for screen-quiz where this is expected. -->
<style scoped>
.-edit-mode-available .edit-mode-warning:not(.screen-quiz *) {
  @apply bg-red-500/30;

  &:after {
    content: '⚠ no editPath';
    font-size: 8px;
  }
}
</style>
